/**
 * Sort a listing array in memory. Used when the result set is assembled
 * client-side (e.g. promotions filter) before pagination.
 * Keys match SearchPage sortConfig + listings-query ORDER BY.
 */

const listingTitle = listing => listing?.attributes?.title || '';

const listingPrice = listing => {
  const amount = listing?.attributes?.price?.amount;
  return typeof amount === 'number' ? amount : 0;
};

const listingRecency = listing => {
  const raw =
    listing?.attributes?.metadata?.updated_at ||
    listing?.attributes?.updatedAt ||
    listing?.attributes?.createdAt ||
    '';
  const t = new Date(raw).getTime();
  return Number.isFinite(t) ? t : 0;
};

export const sortListings = (listings, sort) => {
  if (!Array.isArray(listings) || listings.length < 2) {
    return Array.isArray(listings) ? [...listings] : [];
  }

  const items = [...listings];
  switch (sort) {
    case 'alphabetical':
      items.sort((a, b) =>
        listingTitle(a).localeCompare(listingTitle(b), 'fr', { sensitivity: 'base' })
      );
      break;
    case '-alphabetical':
      items.sort((a, b) =>
        listingTitle(b).localeCompare(listingTitle(a), 'fr', { sensitivity: 'base' })
      );
      break;
    case 'createdAt':
      items.sort((a, b) => listingRecency(b) - listingRecency(a));
      break;
    case '-createdAt':
      items.sort((a, b) => listingRecency(a) - listingRecency(b));
      break;
    case 'price':
      items.sort((a, b) => listingPrice(a) - listingPrice(b));
      break;
    case '-price':
      items.sort((a, b) => listingPrice(b) - listingPrice(a));
      break;
    default:
      break;
  }
  return items;
};
